import { atom, useAtom, useAtomValue } from 'jotai'
import { FEATURE_FLAGS } from '@highlight/analytics'
import { useFlags } from '@highlight/analytics/react'
import type { SearchModelKey } from './sidebar-search-models'

/** What's typed in the sidebar search bar. While it holds text, Home shows search results instead of its sections. */
const sidebarSearchQueryAtom = atom('')

// Derived, so the sidepanel re-renders when search starts or ends rather than on every keystroke.
const isSidebarSearchingAtom = atom((get) => get(sidebarSearchQueryAtom).trim().length > 0)

/** The model the chats started from the bar go to. Auto leaves it to the plan's default model. */
const sidebarSearchModelAtom = atom<SearchModelKey>('auto')

/** The skill picked from the bar's `/` list. It goes with the chat only while the text still names it. */
const sidebarSearchSkillIdAtom = atom<string | null>(null)

/** The row of the `/` list that Enter picks, moved with the arrow keys. */
const sidebarSkillHighlightAtom = atom(0)

export const useSidebarSearchQuery = () => useAtom(sidebarSearchQueryAtom)

export const useSidebarSearchModel = () => useAtom(sidebarSearchModelAtom)

export const useSidebarSearchSkillId = () => useAtom(sidebarSearchSkillIdAtom)

export const useSidebarSkillHighlight = () => useAtom(sidebarSkillHighlightAtom)

export const useIsSidebarSearching = () => useAtomValue(isSidebarSearchingAtom)

export function useCanUseSidebarSearch(): boolean {
  return useFlags({ live: true }).isEnabled(FEATURE_FLAGS.SIDEBAR_SEARCH, false)
}
